import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";
import fetchV3 from "../auth/FetchInterceptorV3";

const authenService = {};

authenService.loginUser = function (data) {
  return fetchV3({
    url: "/api/authenticate",
    method: "post",
    data: data,
  });
};
//get-registered-app
authenService.getRegisteredApp = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/microservice-management/get-registered-app`,
    method: "get",
  });
};
// get final auth
authenService.getFinalAuth = function (data) {
  return fetch({
    url: `${env.API_MSCSM}/api/authorization/gen-app-jwt`,
    method: "post",
    data: data,
  });
};

// get final auth
authenService.generateTokenAzure = function (data) {
  return fetch({
    url: `${env.API_MSCSM}/user/validation-generate-token-azure-v2`,
    method: "post",
    data: data,
  });
};
export default authenService;
